import useAppTranslation from "@hooks/language/useAppTranslation";
import { Button } from "@mantine/core";
import { IconShoppingCart } from "@tabler/icons-react";

interface IBuyNowProps {
  outOfStock?: boolean;
  onClick: () => void;
}

const BuyNow: React.FC<IBuyNowProps> = ({ outOfStock = false, onClick }) => {
  const { t } = useAppTranslation("components.buyNowButton");

  if (outOfStock) {
    return (
      <Button
        disabled
        className="gradient-dark-blue-purple h-12 max-w-fit rounded-xl text-primary-white hover:text-primary-white"
        classNames={{
          label: "font-inter ",
        }}
        rightSection={<IconShoppingCart />}
        onClick={onClick}
      >
        {t("outOfStock")}
      </Button>
    );
  }

  return (
    <Button
      className="gradient-blue-purple hover-scale h-12 max-w-fit rounded-xl text-primary-white hover:text-primary-white"
      classNames={{
        label: "font-inter ",
      }}
      rightSection={<IconShoppingCart />}
      onClick={onClick}
    >
      {t("buyNow")}
    </Button>
  );
};

export default BuyNow;
